export default "__VITE_ASSET__CeyKSR4M__"